export const DEFAULT_EMAIL_SEARCH_PARAM = "email";
export const LANDING_EMAIL_SEARCH_PARAM = "landingemail";
export const CID_SEARCH_PARAM = "cid";

export const APROPO_CAMPAIGN_COOKIE_NAME = "apropo_campaign";